import Vue from "vue";
import Vuex from "vuex";
import app from "./app";
import appConfig from "./app-config";
import authenticate from "./authenticate";
// Modules
import ecommerceStoreModule from '@/views/pages/e-commerce/eCommerceStoreModule';
import language from "./language";
import notification from "./notification";
import verticalMenu from "./vertical-menu";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    authenticate,
    verticalMenu,
    language,
    notification,
    'app-ecommerce': ecommerceStoreModule,
  },
  strict: process.env.DEV,
});
